import React from "react";
import "./About.css";
import aboutImage from "../../assets/me2.png";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";
import { TbStack3 } from "react-icons/tb";
import "animate.css";
// import AOS from 'aos';
import AOS from "aos";
const About = () => {
  AOS.init({
    duration: 1000,
  });
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me" data-aos="fade-left">
          <div className="about__me-image" data-aos="fade-right" data-aos-delay="200">
            <img src={aboutImage} alt="about image" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article
              className="about__card"
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="300"
            >
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>9 Months Working</small>
            </article>
            <article
              className="about__card"
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="500"
            >
              <TbStack3 className="about__icon" />
              <h5>Tech Stack</h5>
              <small>7+ Technologies</small>
            </article>
            <article
              className="about__card"
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="700"
            >
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>7+ completed</small>
            </article>
          </div>

          <p data-aos="fade-down">
          I am eager to bring my expertise in software development to a respected organization, with a strong track record in planning and problem-solving. My aspiration is to collaborate with a forward-thinking company that is at the forefront of technological innovation. Known among my peers for my unwavering focus and dedication, you can trust that I will be a dependable asset in helping your company attain its objectives.
          </p>

          <a href="#contact" className="btn btn-primary" data-aos="fade-down">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
